import React, { useState } from 'react';
import CreateOrUpdateLectureInputTemplate from './CreateOrUpdateLectureInputTemplate'; 
import { createSubSection } from '../../../../services/operations/courseApi'; 
import { useDispatch, useSelector } from 'react-redux';
import updateUserLocalStorage from '../../../../utils/updateUserLocalStorage'; 
import { setViewCourseLoading } from '../../../../redux/slices/viewCourseSlice'; 

const CreateLecture = ({ register, errors, setValue, getValues, setBgBlurModal, section }) => {
    const [duration, setDuration] = useState(0);
    const [lectureData, setLectureData] = useState(null);
    const { courseEntireData } = useSelector(state => state.viewCourse);
    const dispatch = useDispatch();
    const createLectureHandler = async () => {
        if (
            getValues('lectureTitle') &&
            getValues('lectureDescription') &&
            getValues('fileType') &&
            getValues('lectureFile') && duration
        ) {
            const sectionID = section._id;
            const courseID = courseEntireData._id;
            const element = {
                title: getValues('lectureTitle'),
                description: getValues('lectureDescription'),
                duration: duration,
                file: getValues('lectureFile'),
            };
            dispatch(setViewCourseLoading(true));
            try {
                await createSubSection(sectionID, element, courseID);
                await updateUserLocalStorage(dispatch);
            } catch (error) {
                console.log(error.message);
            } finally {
                dispatch(setViewCourseLoading(false));
            }
        }
    };

    return (
        <CreateOrUpdateLectureInputTemplate
            register={register}
            errors={errors}
            setValue={setValue}
            setDuration={setDuration}
            setLectureData={setLectureData}
            lectureData={lectureData}
            createLectureHandler={createLectureHandler}
            setBgBlurModal={setBgBlurModal}
        />
    );
};

export default CreateLecture;